import { render, staticRenderFns } from "./TheAdminSidebar.vue?vue&type=template&id=68a1f675"
import script from "./TheAdminSidebar.vue?vue&type=script&lang=js"
export * from "./TheAdminSidebar.vue?vue&type=script&lang=js"
import style0 from "./TheAdminSidebar.vue?vue&type=style&index=0&id=68a1f675&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports